/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */

import { env } from "@/config/env";

interface AmazonFn {
  (
    command: "styles",
    config: {
      iconType: string;
      openChat: { color: string; backgroundColor: string };
      closeChat: { color: string; backgroundColor: string };
    },
  ): void;

  (command: "snippetId", id: string): void;

  (command: "supportedMessagingContentTypes", types: string[]): void;

  (
    command: "customLaunchBehavior",
    config: {
      skipIconButtonAndAutoLaunch?: boolean;
      alwaysHideWidgetButton?: boolean;
      programmaticLaunch?: (callback: VoidFunction) => void;
    },
  ): void;

  (
    command: "customizationObject",
    config: {
      header?: {
        dropdown?: boolean;
        dynamicHeader?: boolean;
      };
      footer?: {
        disabled?: boolean;
        skipCloseChatButton?: boolean;
      };
    },
  ): void;

  (
    command: "contactAttributes",
    config: {
      PlatformName: string;
      Name: string;
      Phone: string;
      Email: string;
    },
  ): void;

  (
    command: "customerDisplayName",
    config: (callback: (displayName: string) => void) => void,
  ): void;
}

export const initializeAmazonConnect = (
  window: Window,
  document: Document,
  id: string,
) => {
  const SCRIPT_NAME = "amazon_connect";

  const existingScript = document.getElementById(id);

  if (!existingScript) {
    const script = document.createElement("script");
    script.src = env.VITE_AMAZON_CONNECT_CHAT_SOURCE;
    script.async = true;
    script.id = id;
    document.head.appendChild(script);
  }

  (window as any)[SCRIPT_NAME] =
    (window as any)[SCRIPT_NAME] ??
    function () {
      ((window as any)[SCRIPT_NAME].ac =
        (window as any)[SCRIPT_NAME].ac ?? []).push(arguments);
    };

  return (window as any)[SCRIPT_NAME] as AmazonFn;
};
